import axios from 'axios'
import {ResponseHelper} from '../../../../setup/index'
import {API_URL} from '../../../../setup/helpers/apiUrl'
import AuthService from '../../../modules/auth/redux/AuthService'
import {UserModel} from '../../../modules/auth/models/UserModel'
import { Logout } from '../../auth'

export const POST_CUSTOMER_FOR_SMS_URL = `${API_URL}/api/CallCenter/SendCustomerMessageCDSResult`
export const POST_CUSTOMER_FOR_UPDATE_URL = `${API_URL}/api/CallCenter/UpdateKvkkCustomer`
export const POST_CUSTOMER_TO_MCFM_URL = `${API_URL}/api/CallCenter/SendCustomerToMcfm`
export const MUGE_OUT_REQUEST_URL = `${API_URL}/api/Muge/OutFromMuge`



const usr:UserModel =  AuthService.GetCurrentUser() != null ? JSON.parse(AuthService.GetCurrentUser()) : null ;

export async  function PostCustomerForSms(customer:any){
  let resp;
  try{
    await axios.post<ResponseHelper>(POST_CUSTOMER_FOR_SMS_URL,customer,{headers:{"Authorization":"bearer " + usr.accessToken}})
      .then((response) =>{
        console.log("then =>", response);
        resp = response;
      })
      .catch((err) => {
        console.log("thenCatch =>", err.response);
        if(err.response.status === 401){
          Logout();
        }
      });
    return resp;
  }
  catch(err){
    console.log("login error =>", err);
    console.log("catch resp =>", resp);
    return err;
  }
}



export async  function PostCustomerForUpdate(customer:any){
  let resp;
  try{
    await axios.post<ResponseHelper>(POST_CUSTOMER_FOR_UPDATE_URL,customer,{headers:{"Authorization":"bearer " + usr.accessToken}})
      .then((response) =>{
        console.log("then =>", response);
        resp = response;
      })
      .catch((err) => {
        console.log("thenCatch =>", err);
        if(err.response.status === 401){
          Logout();
        }
      });
    return resp;
  }
  catch(err){
    console.log("login error =>", err);
    console.log("catch resp =>", resp);
    return err;
  }
}

export async  function PostCustomerToMcfm(customer:any){
  let resp;
  try{
    await axios.post<ResponseHelper>(POST_CUSTOMER_TO_MCFM_URL,customer,{headers:{"Authorization":"bearer " + usr.accessToken}})
      .then((response) =>{
        console.log("then =>", response);
        resp = response;
      })
      .catch((err) => {
        console.log("thenCatch =>", err);
        if(err.response.status === 401){
          Logout();
        }
      });
    return resp;
  }
  catch(err){
    console.log("login error =>", err);
    console.log("catch resp =>", resp);
    return err;
  }
}

export async  function MugeOutRequest(customerGuid:string){
  let resp;
  try{
    await axios.get<ResponseHelper>(MUGE_OUT_REQUEST_URL+"?customerGuid="+customerGuid)
      .then((response) =>{
        console.log("then =>", response);
        resp = response;
      })
      .catch((err) => {
        console.log("thenCatch =>", err);
        if(err.response?.status === 401){
          Logout();
        }
      });
    return resp;
  }
  catch(err){
    console.log("login error =>", err);
    console.log("catch resp =>", resp);
    return err;
  }
}
